function TravelAgentRate() {
    return (
      <>
        <div className="font-bold text-lg mb-16">TravelAgentRate</div>
      </>
    );
  }
  
  export default TravelAgentRate;